import { render, staticRenderFns } from "./ServiceCategoryRow.vue?vue&type=template&id=2b6a8fff&scoped=true"
import script from "./ServiceCategoryRow.vue?vue&type=script&lang=js"
export * from "./ServiceCategoryRow.vue?vue&type=script&lang=js"
import style0 from "./ServiceCategoryRow.vue?vue&type=style&index=0&id=2b6a8fff&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b6a8fff",
  null
  
)

export default component.exports